export default __webpack_public_path__ + "static/media/grails-cupsonly-logo-white.f727f897.svg";